{
  "moreActions": "Další akce"
}
